import React from 'react';
import { RouteProps } from 'react-router-dom';
import { demoPagesMenu } from '../menu';
import DefaultHeader from '../pages/_layout/_headers/DefaultHeader';

const headers: RouteProps[] = [
	{ path: demoPagesMenu.page404.path, element: null },
	{
		path: `*`,
		element: <DefaultHeader />,
	},
];

export default headers;
